(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire07df"];
var parcelRegister = parcelRequire.register;
parcelRegister("1aFzU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dbcca725d188fe0$export$2e2bcd8739ae039; });

var $2hYdk = parcelRequire("2hYdk");
const $5dbcca725d188fe0$var$shopifyDataSource = ()=>{
    var _window_Shopify;
    if (!window.transactionOrder) {
        var _window_Shopify1;
        if (!((_window_Shopify1 = window.Shopify) === null || _window_Shopify1 === void 0 ? void 0 : _window_Shopify1.checkout)) return;
    } else try {
        var _window, _window1, _transaction_order, _transaction_totalPrice, _transaction_totalTax, _transaction_shippingLine_price, _transaction_shippingLine;
        const transaction = (_window = window) === null || _window === void 0 ? void 0 : _window.transactionOrder;
        const products = (_window1 = window) === null || _window1 === void 0 ? void 0 : _window1.transactionItems;
        (0, $2hYdk.default).notify({
            transactionEvent: {
                id: transaction === null || transaction === void 0 ? void 0 : (_transaction_order = transaction.order) === null || _transaction_order === void 0 ? void 0 : _transaction_order.id,
                total: parseFloat((transaction === null || transaction === void 0 ? void 0 : (_transaction_totalPrice = transaction.totalPrice) === null || _transaction_totalPrice === void 0 ? void 0 : _transaction_totalPrice.amount) || 0),
                tax: parseFloat((transaction === null || transaction === void 0 ? void 0 : (_transaction_totalTax = transaction.totalTax) === null || _transaction_totalTax === void 0 ? void 0 : _transaction_totalTax.amount) || 0),
                shipping: parseFloat((transaction === null || transaction === void 0 ? void 0 : (_transaction_shippingLine = transaction.shippingLine) === null || _transaction_shippingLine === void 0 ? void 0 : (_transaction_shippingLine_price = _transaction_shippingLine.price) === null || _transaction_shippingLine_price === void 0 ? void 0 : _transaction_shippingLine_price.amount) || 0),
                city: "N/A",
                state: "N/A",
                country: "N/A",
                currency: ((transaction === null || transaction === void 0 ? void 0 : transaction.currencyCode) || "USD").toString(),
                items: products === null || products === void 0 ? void 0 : products.map((product)=>{
                    var _transaction_order;
                    const productItem = product === null || product === void 0 ? void 0 : product.variant;
                    return {
                        orderId: transaction === null || transaction === void 0 ? void 0 : (_transaction_order = transaction.order) === null || _transaction_order === void 0 ? void 0 : _transaction_order.id.toString(),
                        productId: product === null || product === void 0 ? void 0 : product.id.toString(),
                        sku: productItem.sku.toString(),
                        name: productItem.product.title.toString(),
                        category: "N/A",
                        unitPrice: parseFloat(productItem.price.amount) || 0,
                        quantity: parseInt(product.quantity) || 1,
                        currency: ((transaction === null || transaction === void 0 ? void 0 : transaction.currencyCode) || "USD").toString()
                    };
                })
            }
        });
    } catch (error) {
    // window.tracker("trackError", JSON.stringify(error), "SHOPIFY");
    }
    // liquid_total_price is legacy support for old shopify integration
    if ((_window_Shopify = window.Shopify) === null || _window_Shopify === void 0 ? void 0 : _window_Shopify.checkout) try {
        const transaction = window.Shopify.checkout;
        const products = transaction.line_items;
        const email = transaction.email || "N/A";
        const orderNumber = document.getElementsByClassName("os-order-number")[0]["innerText"] || "";
        window.tracker("setUserId", email);
        (0, $2hYdk.default).notify({
            transactionEvent: {
                userId: email,
                id: `${(transaction.liquid_order_name || transaction.order_id).toString()} ${orderNumber && `- ${orderNumber}`}`,
                total: parseFloat(transaction.liquid_total_price || transaction.total_price),
                tax: parseFloat(transaction.total_tax || 0),
                shipping: parseFloat(transaction.shipping_rate.price || 0),
                city: (transaction.billing_address.city || "N/A").toString(),
                discount: parseFloat(transaction.discount || 0),
                couponCode: "N/A",
                state: (transaction.billing_address.province || "N/A").toString(),
                country: (transaction.billing_address.country || "N/A").toString(),
                currency: (transaction.currency || "N/A").toString(),
                items: products.map((product)=>{
                    const { id: id, product_id: product_id, title: title, variant_title: variant_title, price: price, quantity: quantity } = product;
                    return {
                        orderId: (transaction.liquid_order_name || transaction.order_id).toString(),
                        productId: (id || product_id).toString(),
                        sku: (id || product_id).toString(),
                        name: (title || "N/A").toString(),
                        category: "N/A",
                        unitPrice: parseFloat(price || 0),
                        quantity: parseInt(quantity || 1),
                        currency: (transaction.currency || "USD").toString()
                    };
                })
            }
        });
    } catch (error) {
    // window.tracker("trackError", JSON.stringify(error), "SHOPIFY");
    }
};
var $5dbcca725d188fe0$export$2e2bcd8739ae039 = $5dbcca725d188fe0$var$shopifyDataSource;

});

})();
//# sourceMappingURL=shopify.a31b6d57.js.map
